import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from 'react-router';

import CustomSelect from '@/views/components/CustomSelect/CustomSelect';

import queryString from 'query-string';
import api from '@/services/api';
import parseObjectToQuery from '@/utils/functions/parseObjectToQuery';
import { Permissions } from "@/utils/permissions/permissions";

const LettersNameAutoSuggest = ({ 
	label, 
	placeholder, 
	tooltipIcon=null,
}) => {
	const [ value, setValue ] = useState("");
	const [ suggestions, setSuggestions ] = useState([]);
	const [ selectedOwner, setSelectedOwner ] = useState();

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const qu = queryString.parse(location.search);

		if (qu.ownerId) {
			setSelectedOwner(qu.ownerId);
		}

		let targetedRoles = Permissions["canCreateLetter"];

		let params = [];
		for (let i = 0; i < targetedRoles.length; ++i) {
			params.push(`roles=${targetedRoles[i]}`);
		}

		const urlParams = params.join('&');
		
		api.get(`/autocomplete/users/role?${urlParams}`)
			.then(response => {
				setSuggestions(getSuggestions(response.data));
			});
	}, []);

	useEffect(() => {
		const found = suggestions.find((val) => { return val.value == selectedOwner; });
		
		if (found) {
			setValue(found);
		}
	}, [ suggestions, selectedOwner ]);

	const getSuggestions = (array) => {
		return array.map((item) => {
			return { value: item.id, label: `${item.forename} ${item.surname} (${item.email})` };
		});
	};

	useEffect(() => {
		const qu = queryString.parse(location.search);

		const found = suggestions.find((val) => { return val.value == qu.ownerId; });

		if (qu.ownerId) {
			setValue(found);
		} else {
			setValue("");
		}
	}, [ location ]);

	const handleChangeOwner = (item) => {
		if(item){
			setValue(item);
			const qu = queryString.parse(location.search);
			return navigate(`${location.pathname}?${parseObjectToQuery({ ...qu, ownerId: item.value })}`);
		} else {
			setValue(item);
			const qu = queryString.parse(location.search);
			if (Object.keys(qu).indexOf('ownerId') !== -1) {
				delete qu.ownerId;
				navigate(`${location.pathname}?${parseObjectToQuery(qu)}`);
			}
		}
	};

	return (
		<CustomSelect
			isClearable
			label={ label }
			placeholder={ placeholder }
			tooltipText={ tooltipIcon }
			value={ value }
			options={ suggestions }
			onChange={ handleChangeOwner }
		/>
	);
};

export default LettersNameAutoSuggest;